import { GetRemoteStringFunction } from '@acorns/web-utils'

import { DateDivider } from './types'

export const getDateKey = (isoDateString: string) => {
  return isoDateString.split('T')[0]
}

/**
 * Formats a date string requirements:
 * - "Today" for current day
 * - "Yesterday" for previous day
 * - "Thu, Jul 9" for earlier dates
 */
const formatChatDate = (
  dateString: string,
  getRemoteString: GetRemoteStringFunction,
): string => {
  const messageDate = new Date(dateString)
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  const messageDateOnly = new Date(
    messageDate.getFullYear(),
    messageDate.getMonth(),
    messageDate.getDate(),
  )
  const todayOnly = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  )
  const yesterdayOnly = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate(),
  )

  if (messageDateOnly.getTime() === todayOnly.getTime()) {
    return getRemoteString({ key: 'global.today' })
  }

  if (messageDateOnly.getTime() === yesterdayOnly.getTime()) {
    return getRemoteString({ key: 'global.yesterday' })
  }

  return messageDate.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  })
}

const getLocalStartOfDay = (isoDateString: string): string => {
  const date = new Date(isoDateString)

  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  const startOfDay = new Date(year, month, day, 0, 0, 0, 0)

  return startOfDay.toISOString()
}

export const buildDateDivider = (
  createdAt: string,
  getRemoteString: GetRemoteStringFunction,
): DateDivider => {
  const localStartOfDay = getLocalStartOfDay(createdAt)

  const dateKey = getDateKey(localStartOfDay)
  return {
    messageType: 'DateDivider',
    id: dateKey,
    text: formatChatDate(localStartOfDay, getRemoteString),
    createdAt: localStartOfDay,
  }
}
